import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/dashboard")({
  head: () => adminHead("Admin Dashboard", "Hadley Energy Solutions admin dashboard.", "/admin/dashboard"),
  component: () => (
    <ProtectedRoute>
      <AdminDashboard />
    </ProtectedRoute>
  ),
});
